import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('mailchimp'),
  titleToNamespace: true,
  avatarPath: avatars.mailchimp,
  logoPath: logos.mailchimp,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'basic'
});
